var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_5983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6376 -0.0332031C9.82361 -0.0332031 4.29968 5.49072 4.29968 12.3047C4.29968 23.8296 16.6376 33.041 16.6376 33.041C16.6376 33.041 28.9754 23.8302 28.9754 12.3047C28.9754 5.49045 23.4512 -0.0334781 16.6376 -0.0332031ZM16.6378 17.756C13.6271 17.756 11.1865 15.3154 11.1865 12.3047C11.1865 9.29397 13.6271 6.85335 16.6378 6.85335C19.6485 6.85335 22.0892 9.29397 22.0892 12.3047C22.0892 15.3154 19.6485 17.756 16.6378 17.756Z",
    fill: "#793EAD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_5983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinSvgrepoCom1);
export default __webpack_public_path__ + "static/media/pin-svgrepo-com_1.0170a678a917abe2702d9588b0b294c1.svg";
export { ForwardRef as ReactComponent };